import { useEffect, useState } from 'react';
import { trackDeviceIdCreated } from '../../utils/zymedSessionDiagnostics';

export interface DeviceInfo {
    browserName: string;
    browserVersion: string;
    osName: string;
    deviceType: string;
}

const useDeviceInfo = (): DeviceInfo | null => {
    const [deviceInfo, setDeviceInfo] = useState<DeviceInfo | null>(null);

    useEffect(() => {
        const userAgent = navigator.userAgent;

        const getBrowserInfo = () => {
            let name = 'Unknown';
            let version = 'Unknown';

            if (/firefox\/\d+/i.test(userAgent)) {
                name = 'Firefox';
                version = userAgent.match(/firefox\/([\d.]+)/i)?.[1] || 'Unknown';
            } else if (/opr\/|opera/i.test(userAgent)) {
                name = 'Opera';
                version = userAgent.match(/(opera|opr)\/([\d.]+)/i)?.[2] || 'Unknown';
            } else if (/edg\//i.test(userAgent)) {
                name = 'Edge';
                version = userAgent.match(/edg\/([\d.]+)/i)?.[1] || 'Unknown';
            } else if (/chrome\/\d+/i.test(userAgent)) {
                name = 'Chrome';
                version = userAgent.match(/chrome\/([\d.]+)/i)?.[1] || 'Unknown';
            } else if (/safari\/\d+/i.test(userAgent)) {
                name = 'Safari';
                version = userAgent.match(/version\/([\d.]+)/i)?.[1] || 'Unknown';
            }

            return { name, version };
        };

        const getOSInfo = () => {
            if (/windows nt 10/i.test(userAgent)) return 'Windows 10';
            if (/windows nt 6.3/i.test(userAgent)) return 'Windows 8.1';
            if (/windows nt 6.2/i.test(userAgent)) return 'Windows 8';
            if (/windows nt 6.1/i.test(userAgent)) return 'Windows 7';
            if (/macintosh|mac os x/i.test(userAgent)) return 'Mac OS';
            if (/android/i.test(userAgent)) return 'Android';
            if (/iphone/i.test(userAgent)) return 'iOS';
            if (/linux/i.test(userAgent)) return 'Linux';
            return 'Unknown';
        };

        const getDeviceType = () => {
           return 'mobile';
        };

        const browser = getBrowserInfo();
        const os = getOSInfo();
        const deviceType = getDeviceType();

        setDeviceInfo({
            browserName: browser.name,
            browserVersion: browser.version,
            osName: os,
            deviceType,
        });

        if( localStorage.getItem('device_info') === null
            || localStorage.getItem('device_type') === null) {
            const previousDeviceInfo = localStorage.getItem('device_info');
            localStorage.setItem('device_info', browser.name+"_"+os+"_"+browser.version);
            const timestamp = Date.now();
            localStorage.setItem('device_type', deviceType+"_"+timestamp);
            trackDeviceIdCreated({ previousDeviceInfo, newDeviceType: deviceType+"_"+timestamp });
        }
    }, []);

    return deviceInfo;
};

export default useDeviceInfo;
